// $z-index-popover:
let popperZIndex = 1060

const nextZIndex = () => {
  return popperZIndex++
}

export default nextZIndex
